var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',[_c('v-layout',[_c('v-flex',[_c('div',[_c('div',{attrs:{"id":"firebaseui-auth-container"}}),_c('div',{attrs:{"id":"loader"}},[_vm._v("\n            Now Loading...\n          ")])])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }